// The chooser's answers, carried to the product page and the cart so the door is never asked
// about twice (Hugh, 18 Sep 2026). They travel in the product link (?slides=…&material=…&door=…)
// and are kept in sessionStorage for the rest of the visit, so hopping between the picks or
// coming back later still starts with the door filled in. A ranchslider is one answer; a hinged
// door is three. Old links still carry the pre-20-Sep values (bore, euro), which map across.
import { isDone } from './lockChooser';

const KEY = 'sd_door_v1';
const SLIDES = ['slides', 'swings'];
const MATERIAL = ['aluminium', 'timber', 'unsure'];
const ON_DOOR = ['mortice', 'multipoint', 'deadbolt', 'lever', 'nightlatch', 'gripset', 'none', 'other'];
const LEGACY_ON_DOOR = { bore: 'deadbolt', euro: 'mortice' };

// Only a complete, well-formed walk counts; anything else is nothing.
function clean(a) {
  if (!a) return null;
  const out = {};
  if (SLIDES.includes(a.slides)) out.slides = a.slides;
  if (out.slides === 'swings') {
    if (MATERIAL.includes(a.material)) out.material = a.material;
    const d = Object.prototype.hasOwnProperty.call(LEGACY_ON_DOOR, a.onDoor) ? LEGACY_ON_DOOR[a.onDoor] : a.onDoor;
    if (ON_DOOR.includes(d)) out.onDoor = d;
  }
  return isDone(out) ? out : null;
}

export function doorQuery(a) {
  const d = clean(a);
  if (!d) return '';
  const q = new URLSearchParams();
  q.set('slides', d.slides);
  if (d.material) q.set('material', d.material);
  if (d.onDoor) q.set('door', d.onDoor);
  return `?${q.toString()}`;
}

export function doorFromParams(params) {
  return clean({ slides: params.get('slides'), material: params.get('material'), onDoor: params.get('door') });
}

export function saveDoor(a) {
  const d = clean(a);
  try {
    if (d) window.sessionStorage.setItem(KEY, JSON.stringify(d));
    else window.sessionStorage.removeItem(KEY);
  } catch {
    /* storage unavailable — the link still carries the answers */
  }
}

export function loadDoor() {
  try {
    const raw = window.sessionStorage.getItem(KEY);
    return raw ? clean(JSON.parse(raw)) : null;
  } catch {
    return null;
  }
}

// The answers on the way in: the link first, the session second.
export function doorForPage(params) {
  const fromLink = doorFromParams(params);
  if (fromLink) { saveDoor(fromLink); return fromLink; }
  return loadDoor();
}

// One line playing the door back: "Aluminium hinged door · a lever and mortice lock on it now".
const ON_DOOR_TEXT = {
  mortice: 'a lever and mortice lock on it now',
  multipoint: 'a lift-to-lock handle on it now',
  deadbolt: 'a round deadlock on it now',
  lever: 'a keyed knob or lever on it now',
  nightlatch: 'a Lockwood-type deadlatch on it now',
  gripset: 'an entrance gripset on it now',
  none: 'no lock on it yet',
  other: 'something else on it',
};
export function describeDoor(a) {
  const d = clean(a);
  if (!d) return '';
  if (d.slides === 'slides') return 'Sliding door (ranchslider)';
  const material = d.material === 'timber' ? 'Timber hinged door' : d.material === 'aluminium' ? 'Aluminium hinged door' : 'Hinged door';
  return `${material} · ${ON_DOOR_TEXT[d.onDoor]}`;
}
